import { render, staticRenderFns } from "./sms-log.vue?vue&type=template&id=67f68802&scoped=true&"
import script from "./sms-log.vue?vue&type=script&lang=js&"
export * from "./sms-log.vue?vue&type=script&lang=js&"
import style0 from "./sms-log.vue?vue&type=style&index=0&id=67f68802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f68802",
  null
  
)

export default component.exports